// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".episodes-list[data-v-62b11bc4]{list-style:none}@media (min-width:960px){.episodes-list[data-v-62b11bc4]{border:1px solid hsla(0,0%,100%,.1)}}.episodes-list li[data-v-62b11bc4]:not(:first-child){border-top:1px solid hsla(0,0%,100%,.1)}.episodes-list .episode[data-v-62b11bc4]:hover{background:hsla(0,0%,93%,.03);cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
